/**
 * GEOM Scroll Animations v2.1
 * Supports TWO animation methods:
 * 1. CSS Classes (.geom-fade-in) - for Liquid sections
 * 2. Inline Styles (data-animate) - for dynamic elements (like original site)
 */

(function() {
  'use strict';
  
  // Configuration
  const CONFIG = {
    threshold: 0.1,
    rootMargin: '0px 0px -50px 0px',
    once: true
  };
  
  /**
   * METHOD 1: CSS Class-based animations
   * For elements with .geom-fade-in class
   */
  function initClassAnimations() {
    const elements = document.querySelectorAll('.geom-fade-in');
    
    if (elements.length === 0) return;
    
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('geom-fade-in-visible');
          if (CONFIG.once) observer.unobserve(entry.target);
        }
      });
    }, CONFIG);
    
    elements.forEach(el => observer.observe(el));
  }
  
  /**
   * METHOD 2: Inline Style-based animations
   * For elements with data-animate attribute
   * This mimics the original GEOM website behavior
   * 
   * Usage:
   * <div data-animate="fade-up">Content</div>
   * <div data-animate="fade-up" data-delay="200">Content with delay</div>
   */
  function initInlineAnimations() {
    const elements = document.querySelectorAll('[data-animate]');
    
    if (elements.length === 0) return;
    
    // Set initial inline styles
    elements.forEach(el => {
      const animationType = el.getAttribute('data-animate');
      
      // Apply initial hidden state
      switch(animationType) {
        case 'fade-up':
          el.style.opacity = '0';
          el.style.transform = 'translateY(20px)';
          break;
        case 'fade-down':
          el.style.opacity = '0';
          el.style.transform = 'translateY(-20px)';
          break;
        case 'fade-left':
          el.style.opacity = '0';
          el.style.transform = 'translateX(20px)';
          break;
        case 'fade-right':
          el.style.opacity = '0';
          el.style.transform = 'translateX(-20px)';
          break;
        case 'fade':
          el.style.opacity = '0';
          break;
        case 'scale':
          el.style.opacity = '0';
          el.style.transform = 'scale(0.95)';
          break;
      }
      
      // Add transition
      el.style.transition = 'opacity 0.8s ease-out, transform 0.8s ease-out';
      
      // Add delay if specified
      const delay = el.getAttribute('data-delay');
      if (delay) {
        el.style.transitionDelay = `${delay}ms`;
      }
    });
    
    // Observe and animate
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const el = entry.target;
          
          // Animate to visible state
          setTimeout(() => {
            el.style.opacity = '1';
            el.style.transform = 'translateY(0) translateX(0) scale(1)';
          }, 10); // Small delay to trigger transition
          
          if (CONFIG.once) observer.unobserve(el);
        }
      });
    }, CONFIG);
    
    elements.forEach(el => observer.observe(el));
  }
  
  /**
   * Initialize all animations
   */
  function init() {
    initClassAnimations();
    initInlineAnimations();
  }
  
  /**
   * Run on DOM ready
   */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  
  /**
   * Shopify Theme Editor support
   */
  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', () => setTimeout(init, 100));
    document.addEventListener('shopify:section:reorder', () => setTimeout(init, 100));
  }
})();
